module.exports = __webpack_public_path__ + "img/cast_logo.a25a0194.svg";